import { NgModule } from '@angular/core';
import { NebulaSplashScreenService } from '@scientifica-cms-fe/services/splash-screen/splash-screen.service';

@NgModule({
    providers: [
        NebulaSplashScreenService
    ]
})
export class NebulaSplashScreenModule
{
    /**
     * Constructor
     */
    constructor(private _nebulaSplashScreenService: NebulaSplashScreenService)
    {
    }
}
